import { dispatchAction } from '@ardoq/rxbeach';
import * as actions from './actions';
import { ViewpointBuilderContext } from 'viewpointBuilder/types';
import { ViewpointBuilderTab } from './types';

export const getViewpointBuilderNavigationCommands = (namespace: string) => ({
  selectTab: (tab: ViewpointBuilderTab) => {
    dispatchAction(actions.selectTab({ tab }), namespace);
  },

  selectViewpointBuilderContext: (context: ViewpointBuilderContext) => {
    dispatchAction(
      actions.selectViewpointBuilderContext({ context }),
      namespace
    );
  },
});

export type ViewpointBuilderNavigationCommands = ReturnType<
  typeof getViewpointBuilderNavigationCommands
>;
